import React from "react";
import classNames from "classnames";
import { formatReportDateUnix } from "@entities/history";
import { FixedAccordion } from "@shared/ui/fixed-accordion";
import { SpriteIcon } from "@shared/ui/SpriteIcon";
import { ReportAccidentsProps } from "./types";
import classes from "./report-accidents.module.scss";

export const ReportAccidents = ({ crashes, crashesHistory, isPdfMode }: ReportAccidentsProps) => {
    return (
        <div className={classes.accidents}>
            <div className={classes.accidents__note}>
                С 2015 года все аварии попадают в базу ГИБДД
            </div>
            {crashes && crashesHistory.length > 0 ? (
                crashesHistory.map((entry, index) => (
                    <FixedAccordion
                        key={index}
                        expanded={isPdfMode}
                        title={
                            <div className={classes.accidents__title}>
                                <div className={classes.accidents__name}>{entry.type}</div>
                                <div className={classes.accidents__info}>
                                    {formatReportDateUnix(entry.date)}, {entry.region}
                                </div>
                            </div>
                        }
                        content={
                            <div className={classes.accidents__details}>
                                <div className={classes.accidents__legend}>
                                    <span
                                        className={classNames(
                                            classes["accidents__dot"],
                                            classes["accidents__dot--yellow"]
                                        )}
                                    />
                                    Без изменения геометрии элементов кузова и эксплуатационных
                                    характеристик автомобиля
                                </div>
                                <div className={classes.accidents__legend}>
                                    <span
                                        className={classNames(
                                            classes["accidents__dot"],
                                            classes["accidents__dot--red"]
                                        )}
                                    />
                                    С изменением геометрии элементов кузова и эксплуатационных
                                    характеристик автомобиля
                                </div>
                                {entry.damageTypes?.length > 0 && (
                                    <div className={classes.accidents__map}>
                                        <SpriteIcon
                                            className={classes.accidents__base}
                                            section="damage-map"
                                            name="damage-map"
                                            width={400}
                                            height={345}
                                        />
                                        {entry.damageTypes.map((damage) => (
                                            <SpriteIcon
                                                key={damage.slug}
                                                section="damage-map"
                                                name={damage.slug}
                                                className={`${classes.accidents__section} ${classes[`accidents__section--${damage.type}`]}`}
                                                width={400}
                                                height={345}
                                            />
                                        ))}
                                    </div>
                                )}
                                <div className={classes.accidents__list}>
                                    {entry?.damageTypes?.map((damage, idx) => (
                                        <div key={idx} className={classes.accidents__item}>
                                            <span
                                                className={classNames(
                                                    classes["accidents__dot"],
                                                    classes[`accidents__dot--${damage.type}`]
                                                )}
                                            />
                                            <div className={classes.accidents__damage}>
                                                <div className={classes.accidents__part}>
                                                    {damage.description}
                                                </div>
                                            </div>
                                        </div>
                                    ))}
                                </div>
                            </div>
                        }
                    />
                ))
            ) : (
                <>
                    <div className={classes.accidents__status}>В ГИБДД нет данных об авариях</div>
                    <div className={classes.accidents__sub}>
                        Автомобиль с этим VIN-номером официально не регистрировался в ДТП.
                    </div>
                </>
            )}
        </div>
    );
};